import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "../ui/tabs";
import PromotionsCodes from "./PromotionsCodes";
import PromotionsOffers from "./PromotionsOffers";

export default function PromotionsTabs() {
    return (
        <Tabs defaultValue="codes" className="w-full">
            <TabsList className="grid w-full grid-cols-2 mb-6">
                <TabsTrigger value="codes">Coupon Codes</TabsTrigger>
                <TabsTrigger value="offers">Special Offers</TabsTrigger>
            </TabsList>
            <TabsContent value="codes">
                <PromotionsCodes />
            </TabsContent>
            <TabsContent value="offers">
                <PromotionsOffers />
            </TabsContent>
        </Tabs>
    );
}
